import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AppService } from "src/app/core/service/app.service";
import { DmsDocument } from "src/app/shared/models/dms-document";
import { Patient } from "src/app/shared/models/patients";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-view",
  templateUrl: "./view.component.html",
  styleUrls: ["./view.component.sass"],
})
export class ViewComponent implements OnInit {
  action: any;
  patient: Patient;
  dmsDocument: DmsDocument;
  imgSrc: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewComponent>,
    private appService: AppService,
    public sanitizer: DomSanitizer
  ) {
    this.patient = new Patient();
    this.action = data.action;
    this.patient = data.patient;
    this.dmsDocument = new DmsDocument();
    if (
      this.patient.ProfilePictureId != null &&
      this.patient.ProfilePictureId != 0
    ) {
      this.getProfilePicture(this.patient.ProfilePictureId);
    }
  }

  ngOnInit(): void {}
  closeDialog(): void {
    this.dialogRef.close();
  }

  getProfilePicture(documentId) {
    const doc = { DocumentId: documentId };
    this.appService.getProfilePicture(doc).subscribe((res: any) => {
      if (!res.HasErrors) {
        this.dmsDocument = Object.assign({}, res);
        if (this.dmsDocument.Base64Url) {
          this.imgSrc = this.getSanitizeUrl(this.dmsDocument.Base64Url);
          this.imgSrc !== 0 ? this.imgSrc : "./assets/images/default-user.png";
        }
      }
    });
  }
  public getSanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
